import React from 'react';

export function FolderUploadIcon(props: React.SVGAttributes<any>) {
    return (
        <svg
            width="52"
            height="37"
            viewBox="0 0 52 37"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M4 3V16.5V17C4 18.6569 5.34314 20 7 20H44.5C46.1569 20 47.5 18.6569 47.5 17V9.5C47.5 7.84315 46.1569 6.5 44.5 6.5H27.5651C26.8761 6.5 26.2081 6.26283 25.6733 5.82834L19.3267 0.671658C18.7919 0.237172 18.1239 0 17.4349 0H7C5.34315 0 4 1.34315 4 3Z"
                fill="currentColor"
                opacity={1}
            />
            <path
                d="M6.32564 34.9288L1.23834 19.3035C0.62727 17.4266 2.02616 15.5 4 15.5H47.5H47.9589C49.9712 15.5 51.4129 17.442 50.8306 19.3682L46.1445 34.8682C45.7618 36.134 44.5953 37 43.2729 37H9.17826C7.87924 37 6.7278 36.164 6.32564 34.9288Z"
                fill="currentColor"
                opacity={0.7}
            />
        </svg>
    );
}
